import { AxiosInstance } from "axios";
import { ApiRouteHelpers } from "../../../root/apiRoutes";
import { OrganizationPublicId } from "../Types";

export interface OrganizationFileDto {
  id: string;
  name: string;
  mimeType: string;
  size: number;
  createdAt: string;
  downloadUrl: string;
}

export class OrganizationFileController {
  constructor(private axios: AxiosInstance) {}

  public getFiles = async (
    organizationId: OrganizationPublicId,
  ): Promise<OrganizationFileDto[]> => {
    const url = ApiRouteHelpers.organization.files.root(organizationId);
    const response = await this.axios.get<OrganizationFileDto[]>(url);
    return response.data;
  };

  public uploadFile = async (
    organizationId: OrganizationPublicId,
    file: File,
  ): Promise<OrganizationFileDto> => {
    const url = ApiRouteHelpers.organization.files.root(organizationId);
    const formData = new FormData();
    formData.append("file", file, file.name);
    const response = await this.axios.post<OrganizationFileDto>(url, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  };

  public deleteFile = async (
    organizationId: OrganizationPublicId,
    fileId: string,
  ): Promise<void> => {
    const url = ApiRouteHelpers.organization.files.specific(organizationId, fileId);
    await this.axios.delete(url);
  };

  public getDownloadUrl = (organizationId: OrganizationPublicId, fileId: string): string => {
    return ApiRouteHelpers.organization.files.download(organizationId, fileId);
  };
}
